import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._onFrameLoad = () => this.syncLayout()
    requestAnimationFrame(() => this.syncLayout())
    this.element.addEventListener("turbo:frame-load", this._onFrameLoad)
  }

  disconnect() {
    this.element.removeEventListener("turbo:frame-load", this._onFrameLoad)
  }

  syncLayout() {
    const children = Array.from(this.element.children)
    const visibleChildren = children.filter((child) => !this.childHidden(child))
    const single = visibleChildren.length === 1

    this.element.classList.toggle("educator-home-page-assessment-summary-cards-row--single", single)

    children.forEach((child) => {
      child.classList.toggle(
        "educator-home-page-assessment-summary-card--full-width",
        single && !this.childHidden(child)
      )
    })

    this.equalizeStatsHeights(single)
  }

  equalizeStatsHeights(single) {
    const statsEls = Array.from(
      this.element.querySelectorAll(
        ".educator-home-page-calibrate-assessments-card__stats, .educator-home-page-practice-smart-quizzes-card__stats"
      )
    ).filter((el) => el.getClientRects().length > 0)

    statsEls.forEach((el) => {
      el.style.minHeight = ""
    })

    if (single || statsEls.length < 2) return

    const maxHeight = Math.max(...statsEls.map((el) => el.getBoundingClientRect().height))
    if (!(maxHeight > 0)) return

    statsEls.forEach((el) => {
      el.style.minHeight = `${maxHeight}px`
    })
  }

  childHidden(child) {
    if (child.classList.contains("hidden")) return true

    const lazyFrame = child.matches("[data-controller~='educator-home-page--lazy-frame']")
      ? child
      : child.querySelector("[data-controller~='educator-home-page--lazy-frame']")

    return Boolean(lazyFrame?.classList.contains("hidden"))
  }
}
